import React, { useState, useEffect, useCallback } from "react";
import "./EpisodeList.css";
import EpisodeListFilter from "./EpisodeListFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  selectedEpisodeList,
  getFilterEpisodeLists,
  getEpisodeFilterOptions,
  setEpisodeListFilterObj,
} from "./redux/EpisodeListSlicer";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import { Table, Badge, Spinner, Form, Pagination } from "react-bootstrap";
// import { Tooltip } from "@mui/material";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Drawer,
  Divider,
  Grid,
  Button,
} from "@mui/material";
import EpisodeListMobile from "./EpisodeListMobile";
import RefershIcon from "../../../common/assets/images/reload.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed, 
  faUserInjured, 
  faUser, 
} from "@fortawesome/free-solid-svg-icons";
import {
  resetDocumentViewerError,
  resetEpisodeIdentifierTopassDocumentViewer,
  resetDocumentViewerLoadedData,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import {
  faSortAmountUp,
  faSortAmountDesc,
} from "@fortawesome/free-solid-svg-icons";
import { setRawSearchQuery } from "../../CodeBook/redux/CodeBookSlicer";
import { handleResetSelectedDetails } from "../../CodeAssist/CodeSearch/redux/codeSearchSlice";
const EpisodeList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;

  //settings needed for responsive mobile
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const navigate = useNavigate();
  const currentLocation = useLocation(); // <- use a unique name

  const [episodeListRowsPerPage, setEpisodeListRowsPerPage] = useState(10);
  const [episodeListCurrentPage, setEpisodeListCurrentPage] = useState(1);
  const [showepisodeListFilter, setShowepisodeListFilter] = useState(false);
  const [selectedPatientType, setSelectedPatientType] = useState(
    episodeListFilterObj?.type_patient?.[0] || null
  )
  const totalPages =
  typeof episodesFilterList?.total_episodes === "number" &&
  typeof episodeListFilterObj?.page_size === "number" &&
  episodeListFilterObj.page_size > 0
    ? Math.max(
        1,
        Math.ceil(
          episodesFilterList.total_episodes / episodeListFilterObj.page_size
        )
      )
    : 1;
  // const indexOfLastEpisode  =  episodeListFilterObj.page * episodeListFilterObj.page_size;
  // const indexOfFirstEpisode =  indexOfLastEpisode - episodeListFilterObj.page_size;
  // const currentEpisodesList =  episodesFilterList?.episode?.slice(0, indexOfFirstEpisode) || [];
  // console.log(episodeListFilterObj.page * episodeListFilterObj.page_size, 'episodeListFilterObj.page')
  const dataToDisplay =
    episodesFilterList?.episode?.length > 0 && episodesFilterList?.episode;
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...episodeListFilterObj,
        page: pageNumber,
      };
       const codeAssistStatusChangePayload = {
      ...episodeListFilterObj,
        status: ["Outstanding"],
        page: pageNumber,
    }

    if(location.pathname === "/Code-Assist-Episode-list"){
      dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
    }else{
      dispatch(setEpisodeListFilterObj(payload));
      dispatch(getFilterEpisodeLists(payload));
    }
      // dispatch(setEpisodeListFilterObj(payload));
      // dispatch(getFilterEpisodeLists(payload));
      // setEpisodeListCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("trackHistory", JSON.stringify([]));
    sessionStorage.setItem("redoStack", JSON.stringify([]));
    const codeAssistStatusChangePayload = {
      ...episodeListFilterObj,
      
      status: ["Outstanding"],
    }

    const codeAccelerateStatusChangePayload = {
      ...episodeListFilterObj,
      status: [],
    }

    if(location.pathname === "/Code-Assist-Episode-list"){
      dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload))
    } else {
      dispatch(getFilterEpisodeLists(codeAccelerateStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAccelerateStatusChangePayload))
    }
  }, [location.pathname]);

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...episodeListFilterObj,
      page: 1,
      page_size: Number(event.target.value),
    };

    const codeAssistStatusChangePayload = {
      ...episodeListFilterObj,
      page: 1,
      page_size: Number(event.target.value),
      status: ["Outstanding"],
    }

    if(location.pathname === "/Code-Assist-Episode-list"){
      dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
      dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
      }else{
      dispatch(setEpisodeListFilterObj(payload));
      dispatch(getFilterEpisodeLists(payload));
    }
    // setEpisodeListRowsPerPage(Number(event.target.value));
    // setEpisodeListCurrentPage(1);
  };
    
  const sortingEpisodeHandler = (name) => {
    const currentSortBy = episodeListFilterObj.sort_by;
    const currentSortOrder = episodeListFilterObj.sort_order;

    const newSortOrder =
      currentSortBy === name && currentSortOrder === "asc" ? "desc" : "asc";

    const payload = {
      ...episodeListFilterObj,
      sort_by: name,
      sort_order: newSortOrder,
    };
    const codeAssistStatusChangePayload = {
      ...episodeListFilterObj,
      sort_by: name,
      sort_order: newSortOrder,
      status: episodeListFilterObj?.status
    }

     if(location.pathname === "/Code-Assist-Episode-list"){
      dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
    dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
      
    }else{
      dispatch(getFilterEpisodeLists(payload));
    dispatch(setEpisodeListFilterObj(payload));
      
    }

    // dispatch(setEpisodeListFilterObj(payload));
    // dispatch(getFilterEpisodeLists(payload));
  };  

  const getPatientTypeIcon = (patientType) => {
  const type = patientType?.toLowerCase();
  
  if (type?.includes('inpatient') || type === 'in-patient') {
    return faBed;
  } else if (type?.includes('outpatient') || type === 'out-patient') {
    return faUserInjured;
  }
  return faUser; // default icon
};

const getPatientTypeColor = (patientType) => {
  const type = patientType?.toLowerCase();
  
  if (type?.includes('inpatient') || type === 'in-patient') {
    return '#4CAF50'; 
  } else if (type?.includes('outpatient') || type === 'out-patient') {
    return '#2196F3'; 
  }
  return '#757575'; 
};

 

  const closeEpisodeFilterModal = () => {
    setShowepisodeListFilter(false);
  };

  const debounceSearchHandler = useCallback(
      debounce((payload) => {
        dispatch(getFilterEpisodeLists(payload))
      }, 1000),
      []
    );

  const handleEpisodeIdentiferSearch = (e) => {
    const payload = {
      ...episodeListFilterObj,
      episode_identifier:
        e?.target?.value?.length > 0 ? e?.target?.value : "",
    };
    const codeAssistStatusChangePayload = {
        ...episodeListFilterObj,
      episode_identifier:
        e?.target?.value?.length > 0 ? e?.target?.value : "",
      status: ["Outstanding"]
    }

     if(location.pathname === "/Code-Assist-Episode-list"){
    dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
      
    }else{
    dispatch(setEpisodeListFilterObj(payload));
      
    }
    // dispatch(setEpisodeListFilterObj(payload))
    debounceSearchHandler(payload);
  }

  return isSmallScreen ? (
    <EpisodeListMobile />
  ) : (
    <div className="episodelist-section">
      <div className="episodelist-header">
        <div className="episodelist-header-section">
          <h4 className="episodelist-header-text">Episode List</h4>
          <span className="episodelist-header-text-total">{`(${
            episodesFilterList?.total_episodes
              ? episodesFilterList?.total_episodes
              : 0
          })`}</span>
        </div>
        <div className="episodelist-filter-section">
          <Box sx={{mr: 1}}>
            <input className="episodelist-filter-episode-identifier" placeholder="Search episode identifer"
                    value={episodeListFilterObj?.episode_identifier}
             onChange={handleEpisodeIdentiferSearch} />
          </Box>
          <span
            class="episodelist-refresh-btn"
            onClick={() => {
              const payload = {
                  medical_record_number: "",
                  // hospital_identifier: "",
                  admission_date: "",
                  separation_date: "",
                  length_of_stay: null,
                  speciality: [],
                  drg: [],
                  status: [],
                  sort_by: "asc",
                  sort_order: "",
                  page_size: 20,
                  page: 1,
                  document_name: [],
                  episode_identifier: "",
                  // Provisional_NWAU: "",
                  // documentTypes: "",
                  // aIProcessingStatus: ""
                  // priority: "",
              }
              
               const codeAssistStatusChangePayload = {
                  medical_record_number: "",
                  // hospital_identifier: "",
                  admission_date: "",
                  separation_date: "",
                  length_of_stay: null,
                  speciality: [],
                  drg: [],
                  status: ["Outstanding"],
                  sort_by: "asc",
                  sort_order: "",
                  page_size: 20,
                  page: 1,
                  document_name: [],
                  episode_identifier: "",
                  // Provisional_NWAU: "",
                  // documentTypes: "",
                  // aIProcessingStatus: ""
                  // priority: "",
    }

     if(location.pathname === "/Code-Assist-Episode-list"){
    dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
    dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
    }else{
    dispatch(setEpisodeListFilterObj(payload));
    // dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));

    }
            }}
          >
            {/* <span> */}
              <img src={RefershIcon} alt="img" />
            {/* </span> */}
          </span>
          <Button
            className="episodelist-filter-btn"
            onClick={() => {
              setShowepisodeListFilter(!showepisodeListFilter);
              dispatch(getEpisodeFilterOptions());
            }}
          >
            Filters
          </Button>
        </div>
      </div>
      <div
        className="episodelist-table-container"
        style={{ overflowX: "auto" }}
      >
        <Table
          // responsive="sm"
          style={{ textAlign: "center" }}
          className={`${
            episodesFilterList?.episode?.length <= 0 ||
            episodesFilterList?.episode?.length === undefined ||
            episodesFilterListLoading ||
            episodesFilterListError
              ? "episodelist-filter-table-loading"
              : "episodelist-filter-table"
          }`}
        >
          <thead className="episodelist-thead">
            <tr className="episodelist-tr">
              {codebookusaEnv && <th className="episodelist-th">
                
                  <div>
                    <span>Episode Type</span>
                     
                  </div>
              </th>
}
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("medical_record_number")}
                >
                 
                  <div>
                    <span>UR Number</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "medical_record_number" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by ===
                        "medical_record_number" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("episode_identifier")}
                >
                  <div>
                    <span> Episode Number</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "episode_identifier" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "episode_identifier" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("admission_date")}
                >
                  <div>
                    <span>Admission Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "admission_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "admission_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("separation_date")}
                >
                  <div>
                    <span>Discharge Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "separation_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "separation_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("length_of_stay")}
                >
                  <div>
                    <span>LOS</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "length_of_stay" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "length_of_stay" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("speciality")}
                >
                  <div>
                    <span>Speciality</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "speciality" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "speciality" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {/* <th className="episodelist-th">
                <div className="episodelist-th-container" onClick={() => sortingEpisodeHandler("created_at")}>
                  <div>
                    <span>Created At</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "asc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "desc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    }
                  </div>
                </div>
              </th> */}

              <th className="episodelist-th" style={{ minWidth: "100px" }}>
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("drg")}
                >
                  <div>
                    <span>Drg</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "drg" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "drg" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th" style={{ minWidth: "200px" }}>
                <div
                  className="episodelist-th-container-status"
                  onClick={() => sortingEpisodeHandler("status")}
                >
                  <div>
                    <span>Status</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "status" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "status" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {location.pathname != "/Code-Assist-Episode-list" && (
                <th className="episodelist-th">
                  <div
                    className="episodelist-th-container"
                    onClick={() => sortingEpisodeHandler("no_of_documents")}
                  >
                    <div>
                      <span>No of documents</span>
                    </div>
                    <div>
                      {episodeListFilterObj.sort_by === "no_of_documents" &&
                      episodeListFilterObj.sort_order === "asc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "no_of_documents" &&
                        episodeListFilterObj.sort_order === "desc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      )}
                    </div>
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {episodesFilterListLoading ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  <Spinner />{" "}
                </div>
              </td>
            ) : episodesFilterListError ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  Something went wrong
                </div>
              </td>
            ) : dataToDisplay?.length > 0 ? (
              dataToDisplay?.map((episode, episodeIndex) => {
                return (
                  <tr
                    key={episode.episode_number}
                    onDoubleClick={() => {
                      dispatch(setRawSearchQuery(""))
                      dispatch(handleResetSelectedDetails())
                      const currentPath = currentLocation.pathname;
                      const destinationPath =
                        currentPath === "/Code-Assist-Episode-list"
                          ? "/Code-Assist"
                          : "/coder";

                      navigate(destinationPath);
                      dispatch(resetEpisodeIdentifierTopassDocumentViewer())
                      localStorage.setItem('currentPage', 'episodeList');
                      localStorage.setItem('filters', JSON.stringify(episodeListFilterObj));
                      localStorage.setItem('last_hcp_line_id', JSON.stringify(episode?.hcp_line_id ?episode?.hcp_line_id:"")) 
                      localStorage.setItem('currentEpisodeIndex', episodeIndex) 
                      dispatch(resetDocumentViewerLoadedData());
                      dispatch(selectedEpisodeList(episode));
                      dispatch(resetDocumentViewerError());
                    }}
                  >
                    {/* <td className="episodelist-td">
                      <Tooltip title={episode?.type_patient}>
                        {episode?.type_patient
                          ? episode?.type_patient
                          : "-"}
                      </Tooltip>
                    </td> */}
                    {codebookusaEnv &&<td className="episodelist-td">
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {episode?.type_patient ? (
      <>
        <Tooltip title={episode.type_patient}>
          <FontAwesomeIcon 
            icon={getPatientTypeIcon(episode.type_patient)} 
            style={{ 
              color: getPatientTypeColor(episode.type_patient),
              fontSize: '16px'
            }}
          />
        </Tooltip>
        <span style={{ marginLeft: '4px' }}>
          {/* {episode.type_patient} */}
          {episode.type_patient.charAt(0).toUpperCase() + episode.type_patient.slice(1)}

        </span>
      </>
    ) : (
      <>
        <FontAwesomeIcon 
          icon={faUser} 
          style={{ 
            color: '#757575',
            fontSize: '16px'
          }}
        />
        <span style={{ marginLeft: '4px' }}>-</span>
      </>
    )}
  </div>
</td>}
                    <td className="episodelist-td">
                      <Tooltip title={episode.medical_record_number}>
                        {episode.medical_record_number
                          ? episode.medical_record_number
                          : "-"}
                      </Tooltip>
                    </td>
                    <td className="episodelist-td">
                      {episode.episode_identifier
                        ? episode.episode_identifier
                        : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.admission_date ? episode.admission_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.separation_date ? episode.separation_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.length_of_stay ? episode.length_of_stay : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.speciality ? episode.speciality : "-"}
                      {/* {episode.drg === "392" ? (
                        <>
                          <Tooltip
                            title={
                              "Esophagitis, Gastroenteritis and Miscellaneous Digestive Disorders without MCC"
                            }
                          >
                            Esophagitis, Gastroenteritis and Miscellaneous
                            Digestive Disorders without MCC
                          </Tooltip>
                        </>
                      ) : episode.drg === "334" ? (
                        <Tooltip title={"Rectal Resection without CC/MCC"}>
                          Rectal Resection without CC/MCC
                        </Tooltip>
                      ) : episode.drg === "331" ? (
                        <Tooltip
                          title={
                            "Major Small and Large Bowel Procedures without CC/MCC"
                          }
                        >
                          Major Small and Large Bowel Procedures without CC/MCC
                        </Tooltip>
                      ) : episode.drg === "462" ? (
                        <Tooltip
                          title={
                            "Bilateral or Multiple Major Joint Procedures of Lower Extremity without MCC"
                          }
                        >
                          Bilateral or Multiple Major Joint Procedures of Lower
                          Extremity without MCC
                        </Tooltip>
                      ) : episode.drg === "502" ? (
                        <Tooltip
                          title={"Soft Tissue Procedures without CC/MCC"}
                        >
                          Soft Tissue Procedures without CC/MCC
                        </Tooltip>
                      ) : (
                        "-"
                      )} */}
                    </td>
                    {/* <td className="episodelist-td">
                      {episode.created_at ? episode.created_at : "-"}
                    </td> */}
                    <td
                      className={`episodelist-td ${
                        episode.status === "Coding Complete" ||
                        episode.status === "aCS Coding Complete"
                          ? "episodelist-td-min-bold-drg"
                          : episode.status ===
                              "AI processing complete - codes available for validation" &&
                            episode.drg !== "No DRG"
                          ? "episodelist-td-bold-drg"
                          : "episodelist-td-normal-drg"
                      }`}
                    >
                      {/* <td className={`episodelist-td ${episode.status === "Coding Complete" ? "Coding Complete" : episode.status === "aCS Coding Complete" ? "aCS Coding Complete" : episode.status === "AI processing complete - codes available for validation" ? "episodelist-td-bold-drg" : "episodelist-td-normal-drg"}`}> */}
                      {episode.drg ? episode.drg : "-"}
                      {/* { 
                        episode?.drg === "U60Z" ? 885 : 
                        episode?.drg === "960Z" ? 981 : 
                        episode?.drg === "G48B" ? 603 : 
                        episode?.drg === "G48A" ? 603 : 
                        episode?.drg === "Q60B" ? 820 : 
                        episode?.drg === "I04A" ? 280 : 
                        episode?.drg === "I04B" ? 280 : 
                        episode?.drg === "K60B" ? 637 : 
                        "-"
                      } */}
                    </td>
                    <td className="episodelist-td-status">
                      <Badge
                        ref={(badge) => {
                          if (badge) {
                            badge.style.setProperty(
                              "background-color",
                              episode?.status_color,
                              "important"
                            );
                            badge.style.setProperty("display", "flex");
                            {
                              episode.status ===
                              "AI processing complete - codes available for validation"
                                ? badge.style.setProperty("color", "black")
                                : badge.style.setProperty("color", "black");
                            }
                            badge.style.setProperty("align-items", "center");
                            badge.style.setProperty(
                              "justify-content",
                              "center"
                            );
                            badge.style.setProperty("height", "30px");
                            badge.style.setProperty("width", "100%");
                            badge.style.setProperty("font-size", "11px");
                            badge.style.setProperty("white-space", "normal"); // Allow text to wrap
                            badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                            badge.style.setProperty(
                              "text-overflow",
                              "ellipsis"
                            ); // Add ellipsis if text overflows
                          }
                        }}
                      >
                        {episode?.status || "-"}
                      </Badge>
                    </td>
                    {location.pathname != "/Code-Assist-Episode-list" && (
                      <td className="episodelist-td">
                        {episode?.document_count > 0
                          ? episode?.document_count
                          : 0}
                      </td>
                    )}
                    {/* <td className='episodelist-td'> <Badge style={{ backgroundColor: `${episode?.status_color} !important`  || "#defaultColor !important" }}>{episode.status ? episode.status : "-"}</Badge></td> */}
                    {/* <td className='episodelist-td'>{episode.priority ? episode.priority : "N/A"}</td> */}
                  </tr>
                );
              })
            ) : (
              <td colspan="10" style={{border:"none", height: '82vh'}}>
                <div className="episodelist-table-error">Can’t find an episode? Use search to view all statuses. Only AI-processed episodes are shown here</div>
              </td>
            )}
          </tbody>
        </Table>
      </div>
      <div className="episodelist-footer">
        <div>
          <Pagination className="episodelist-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={episodeListFilterObj?.page <= 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(episodeListFilterObj?.page - 1)}
              disabled={episodeListFilterObj?.page <= 1}
              className="episodelist-prev-btn"
            />
            <Pagination.Item>
              Page {episodeListFilterObj?.page} of {totalPages}
            </Pagination.Item>

            <Pagination.Next
              onClick={() => handlePageChange(episodeListFilterObj?.page + 1)}
              disabled={episodeListFilterObj?.page >= totalPages}
              className="episodelist-next-btn"
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={episodeListFilterObj.page === totalPages}
            />
          </Pagination>
        </div>
        <div className="episodelist-row-options">
          <Form.Select
            className="episodelist-select"
            value={episodeListFilterObj.page_size}
            onChange={handleRowsPerPageChange}
          >
            <option value="" disabled className="episodelist-rows-per-page">
              Rows per page
            </option>
            {/* <option value={10} className="episodelist-rows-per-page">10</option> */}
            <option value={20} className="episodelist-rows-per-page">
              20
            </option>
            <option value={50} className="episodelist-rows-per-page">
              50
            </option>
            <option value={100} className="episodelist-rows-per-page">
              100
            </option>
          </Form.Select>
        </div>
      </div>
      <EpisodeListFilter
        showepisodeListFilter={showepisodeListFilter}
        setShowepisodeListFilter={setShowepisodeListFilter}
        closeEpisodeFilterModal={closeEpisodeFilterModal}
      />
    </div>
  );
};

export default EpisodeList;
